export const HTTP_INTERNAL_ERROR_CODE = 500;
export const HTTP_NOT_FOUND_CODE = 404;
export const HTTP_UNAUTHORIZED_CODE = 401;
export const HTTP_NOT_CONNECTION_CODE = 0;
export const MS_CONVERT_NUM = 1000;
export const MIN_DURATION_IDLE = 1000;